var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlacktwiter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1417 18.4598L11.5935 8.94578L10.8531 7.86975L6.16794 1.06401L5.77982 0.5H0.0234375L1.4272 2.54016L7.65644 11.5901L8.39682 12.665L13.4015 19.9371L13.7898 20.5005H19.5461L18.1417 18.4598ZM14.4727 19.1978L9.2736 11.6434L8.53321 10.568L2.50026 1.80192H5.09554L9.97482 8.89115L10.7152 9.96651L17.0688 19.1976L14.4727 19.1978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53281 10.5681L9.27319 11.6435L8.39543 12.665L1.66076 20.5001H0L7.65505 11.5902L8.53281 10.5681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8505 0.5L11.5908 8.94578L10.713 9.96668L9.97266 8.89132L10.8504 7.86975L15.768 2.14595L17.1897 0.5H18.8505Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5447,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacktwiter);
export default __webpack_public_path__ + "static/media/blacktwiter.c1919eabb2e3e0f8f4047be875d8be01.svg";
export { ForwardRef as ReactComponent };